import Paper from "@mui/material/Paper";
import { useLocation } from "react-router-dom";
import AgreementShow from "./AgreementShow";
import AgreementAnalyzeForm from "./AgreementAnalyzeForm";

export default function AgreementAnalyze() {
  const { state } = useLocation();
  const { id, generateReport, agreement_type } = state;

  return (
    <>
      <AgreementShow title="Analizar convenio" />
      <Paper elevation={0} sx={{ padding: 5 }}>
        <AgreementAnalyzeForm
          id={id}
          displayHeader={false}
          generateReport={generateReport}
          agreement_type={agreement_type}
        />
      </Paper>
    </>
  );
}
